import {
  GetActivityVoiceWaiting,
  UpdateActivityCounter,
  UpdateActivityVoiceWaiting,
  sendActivity,
} from "../../Utils/botUtils";

const botEventHandler: Function = (action: any) => {
  console.log(action);
  if (!action) {
    return false;
  }

  if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
    //Increment counter activity
    UpdateActivityCounter("+");
  }
  if (action.type === "DIRECT_LINE/POST_ACTIVITY_FULFILLED") {
    //Decrement counter activity
    UpdateActivityCounter("-");
  }

  if (
    action.type === "DIRECT_LINE/POST_ACTIVITY_FULFILLED" &&
    action.payload.activity.type === "event" &&
    action.payload.activity.name === "setUser"
  ) {
    // Bot Started
    // Inject CSS to Shadow
    const host = document.querySelector("#retorik-shadow");
    if (host && host.shadowRoot) {
      // Inject shadow dom custom CSS
      const sheets = Array.from(document.styleSheets);
      const styleToInject = sheets.filter((s: CSSStyleSheet) => {
        return Array.from(s.cssRules).some(
          (c: CSSRule) => c.cssText.indexOf("#retorik-shadow") > -1
        );
      });
      if (styleToInject && styleToInject.length > 0) {
        console.log("styleToInject", styleToInject);
        styleToInject.forEach((s) => {
          const host = document.querySelector("#retorik-shadow");
          const rules = Array.from(s.cssRules).filter(
            (c: CSSRule) => c.cssText.indexOf("#retorik-shadow") > -1
          );
          console.log(rules.map((r) => r.cssText));
          const strCss: string = rules.map((r) => r.cssText).join(" ");
          console.log(strCss);
          const style = document.createElement("style");
          style.innerHTML = strCss.replaceAll("#retorik-shadow", ":host");
          if (host && host.shadowRoot) host.shadowRoot.appendChild(style);
        });
      }
    }
  }
  if (
    action.type === "DIRECT_LINE/POST_ACTIVITY_FULFILLED" &&
    action.payload.activity.type === "event" &&
    action.payload.activity.name === "setUser"
  ) {
    UpdateActivityCounter("reset");

    //Start event
    let Event_Start = new CustomEvent("ChatbotEvent", {
      detail: {
        name: "Event_Start",
      },
    });
    document.dispatchEvent(Event_Start);
  }

  if (action.type === "DIRECT_LINE/INCOMING_ACTIVITY") {
    if (action?.payload?.activity?.type === "message") {
      const AjadiEvent = new CustomEvent("ChatbotEvent", {
        detail: {
          name: "AJADI_SetVoiceMode",
        },
      });
      document.dispatchEvent(AjadiEvent);
    }
    if (action.payload.activity.meta) {
      let meta = action.payload.activity.meta;
      //Gestion Voice
      if (meta?.WaitForVoiceFinish && meta?.WaitForVoiceFinish === "true") {
        console.log("WaitForVoiceFinish TRUE");
        let voiceWaiting = GetActivityVoiceWaiting();
        if (!voiceWaiting) {
          UpdateActivityVoiceWaiting(true, action.payload.activity.id);
          const AjadiEvent = new CustomEvent("ChatbotEvent", {
            detail: {
              name: "AJADI_WaitingActivitySpeakEnd",
            },
          });
          document.dispatchEvent(AjadiEvent);
        }
        //localStorage.setItem("WaitForVoiceFinish", action.payload.activity.id);
      }
    }
  }

  /*if (action.type === "WEB_CHAT/MARK_ACTIVITY") {
    let storedVoiceActivity = localStorage.getItem("WaitForVoiceFinish");
    if (
      storedVoiceActivity &&
      action.payload.activityID === storedVoiceActivity &&
      action.payload.name === "speak" &&
      action.payload.value === false
    ) {
      console.log("WaitForVoiceFinish Voice Ended");

      localStorage.removeItem("WaitForVoiceFinish");

      sendActivity({
        type: "event",
        name: "continueDialog",
        value: "voiceFinish",
      });
    }
  }*/

  if (
    action?.payload?.activity?.type === "event" &&
    action.type === "DIRECT_LINE/INCOMING_ACTIVITY"
  ) {
    if (action.payload.activity.name.indexOf("AJADI_Event") > -1) {
      const AjadiEvent = new CustomEvent("ChatbotEvent", {
        detail: action.payload.activity,
      });
      document.dispatchEvent(AjadiEvent);
    } else if (action.payload.activity.name === "AJADI_Questionnaire") {
      const AjadiEvent = new CustomEvent("ChatbotEvent", {
        detail: {
          name: "AJADI_Questionnaire",
        },
      });
      document.dispatchEvent(AjadiEvent);
    }
  }

  if (
    action &&
    action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type === "event" &&
    action.payload.activity.name === "GetUserCompany"
  ) {
    let Event_GetUserCompany = new CustomEvent("ChatbotEvent", {
      detail: {
        name: "GetUserCompany",
      },
    });
    document.dispatchEvent(Event_GetUserCompany);
  }
  if (
    action &&
    action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type === "event" &&
    action.payload.activity.name === "GetUserMail"
  ) {
    let Event_GetUserMail = new CustomEvent("ChatbotEvent", {
      detail: {
        name: "GetUserMail",
      },
    });
    document.dispatchEvent(Event_GetUserMail);
  }

  if (
    action &&
    action.type === "DIRECT_LINE/INCOMING_ACTIVITY" &&
    action.payload &&
    action.payload.activity &&
    action.payload.activity.type === "event" &&
    action.payload.activity.name === "GetUserData"
  ) {
    let Event_GetUserData = new CustomEvent("ChatbotEvent", {
      detail: {
        name: "GetUserData",
      },
    });
    document.dispatchEvent(Event_GetUserData);
  }

  return false;
};

export { botEventHandler };
